import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  applyRevisionSchema,
  nodeActionSchema,
  nodeDesignsEntitySchema,
} from "@skilitics/nautilus-core-designer-data/schemas";

// Hack to resolve TS2742. `import type {} from ...` works too, but gets automatically removed as unused :(
export type * as DataSchemas from "@skilitics/nautilus-core-designer-data/schemas";

const revisionMismatchResponseSchema = z.object({
  message: z.string(),
  suppliedRevision: z.number(),
  current: z.object({
    revision: z.number(),
    checksum: z.number().int().nullable(),
  }),
});

export const contentApi = makeApi([
  {
    method: "get",
    path: "/node-designs/:hostId",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
    ],
    alias: "getNodeDesigns",
    description: "Get Node Designs",
    response: nodeDesignsEntitySchema,
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
      {
        status: 418,
        schema: z.string(),
      },
      {
        status: 403,
        schema: z.string(),
      },
    ],
  },
  {
    method: "post",
    path: "/node-designs/:hostId/revisions",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Body",
        name: "revision",
        schema: applyRevisionSchema,
      },
    ],
    alias: "postNodeDesignsRevision",
    description: "POST node designs revision",
    response: z.void(),
    status: 204,
    errors: [
      {
        status: 400,
        schema: z.array(
          z.object({
            message: z.string(),
            action: nodeActionSchema,
          }),
        ),
      },
      {
        status: 409,
        schema: revisionMismatchResponseSchema,
      },
      {
        status: 418,
        schema: z.string(),
      },
      {
        status: 403,
        schema: z.string(),
      },
      {
        status: 404,
        schema: z.string(),
      },
    ],
  },
  {
    method: "patch",
    path: "/node-designs/:hostId/revisions/:revision",
    alias: "patchNodeDesignsRevision",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "revision",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "payload",
        schema: z.object({
          skip: z.boolean(),
        }),
      },
    ],
    status: 204,
    response: z.void(),
    errors: [
      {
        status: 403,
        schema: z.array(z.string()),
      },
      // The module is gone. A revision that cannot be undone/redone is a 409, not a 404.
      {
        status: 404,
        schema: z.string(),
      },
      // The module is here, but that revision is not one the server can skip/unskip.
      {
        status: 409,
        schema: z.string(),
      },
    ],
  },
]);
